import SeparatorList, { SEPARATOR_TYPES } from './SeparatorList';

export { SEPARATOR_TYPES };
export default SeparatorList;
